import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

// STYLES
import { showLogoBackground } from '@/styles/background';

export const Wrapper = styled.div`
  &.hero-section,
  .hero-section {
    &__left-section {
      display: flex;
      flex-direction: column;
      justify-content: center;

      ${breakpoints.down('md')} {
        max-width: 500px;
        margin: 0 auto;
      }
    }

    &__content {
      &-image-wrapper {
        position: relative;
        overflow: hidden;
        border-radius: 8px;

        margin: 0 auto 15px;

        &.content__votes {
          ${showLogoBackground}
        }
      }

      .movie-votes {
        position: absolute;
        bottom: 25px;
        left: 50%;
        transform: translateX(-50%);
      }

      &-image {
        width: 100%;
        height: auto;
        max-width: 355px;

        ${breakpoints.down('xs')} {
          max-width: 196px;
        }
      }

      &-description {
        width: 100%;
      }

      &-trailer-button {
        //display: block;
        margin: 32px auto 0;
      }

      &-info {
        .info_value {
          display: inline-block;
          margin-left: 8px;
          font-weight: bold;
          white-space: nowrap;
        }
      }

      &-buttons {
        margin-top: 8px;
      }
    }

    &__back-link {
      display: inline-flex;
      align-items: center;
      padding-top: 20px;

      i {
        font-size: 0.8rem;
        line-height: 1.7rem;
        margin-right: 5px;
      }
    }

    &__report-link {
      font-size: 1.4rem;
      line-height: 1.6rem;
    }

    &--dialog {
      .main-content {
        padding-top: 40px;
        padding-bottom: 40px;
      }

      .hero-section {
        &__left-section {
          width: 100%;
          max-width: 350px;
        }

        &__content {
          &-image {
            max-width: 255px;
          }

          &-description {
            max-width: 540px;
          }

          .where-to-watch__section {
            margin: 35px 0 0;
          }

          .where-to-watch:not(.where-to-watch__no-results) + .hero-section__report-link {
            margin-top: -40px;
          }

          ${breakpoints.only('md')} {
            &-buttons {
              .MuiButton-root {
                min-width: initial !important;
              }
            }
          }
        }
      }

      .add-remove-btn--with-status {
        .MuiButton-label {
          font-size: 1.2rem;
          font-weight: 400;
        }
      }
    }
  }

  .breadcrumbs + .main-content {
    padding-top: 30px;
  }

  .where-to-watch:not(.where-to-watch__no-results) + .hero-section__report-link {
    position: relative;
    z-index: 1;
    margin-top: -60px;

    ${breakpoints.down('xs')} {
      margin-top: 0;
    }
  }

  .hero-section__back-link + .main-content {
    padding-top: 20px;
  }
`;

// export const VideoWrapper = styled.div`
//   margin: 0 auto;

//   .video-wrapper {
//     position: relative;
//     padding: 33.35% 0; /* 16:9 */
//     height: 0;
//   }

//   .video-wrapper iframe {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//   }
// `;

export default Wrapper;
